import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';
import { slugify } from '@bridebook/toolbox/src';
import { Box } from '@bridebook/ui';
import SectionHeading from '@bridebook/web/app-shared/components/supplier/sections/section-heading';
import msg, { MsgKey } from '@bridebook/web/app-shared/lib/supplier/msg';
import componentStyles from './section.style';
import { IconApprove } from '@bridebook/ui/src/icons/dynamic';

type Details = ISupplier['typeDetails'][keyof ISupplier['typeDetails']];

export type TSupplierDetailsSectionVersion = 'v1' | 'v2';
interface IProps {
  section?: string[];
  name: string;
  last?: boolean;
  details: Details;
}

const Section: React.FC<IProps> = ({ section, name, last, details }) => {
  const styles = componentStyles(last);

  const renderFeature = (featureItem: string) => {
    const isOther = featureItem === 'other';
    const otherValue = isOther ? details?.[`${name}Other` as keyof typeof details] : '';
    const message = msg[featureItem as MsgKey]?.();
    if ((!isOther && !message) || (isOther && !otherValue)) {
      return;
    }
    return (
      <Box style={styles.itemWrap} key={`sec-item-${slugify(featureItem)}`}>
        <Box style={styles.iconWrap}>
          <IconApprove width={16} color="indigoCrush" />
        </Box>
        <Box style={styles.text}>{(isOther ? otherValue : message) as string}</Box>
      </Box>
    );
  };

  return (
    <Box style={styles.wrapper}>
      <SectionHeading noMargin>{msg[name as MsgKey]?.()}</SectionHeading>
      <Box style={styles.itemSection}>{section && section.map((item) => renderFeature(item))}</Box>
    </Box>
  );
};

export default Section;
